import { useQuery } from "@tanstack/react-query";

import useUser from "./useUser";
import API from "../../api/API";
import { Credential } from "../../../types/GlobalInterfaces";

const useUserAccounts = () => {
  const { user } = useUser();

  const userAccounts = useQuery<Credential[]>({
    queryKey: ["userAccounts", user?.id],
    queryFn: () => API.getUserAccounts(user?.id).then((data) => data.data.data),
    enabled: !!user?.id,
  });

  return {
    userAccounts: userAccounts.data,
    userAccountsLoading: !user?.id ? true : userAccounts.isLoading,
    userAccountsError: userAccounts.isError,
  };
};

export default useUserAccounts;
